import React from 'react';
import CssButton from "./pages/tool-cssButton";

function App() {
  return (
    <>
      <CssButton />
    </>
  );
}

export default App;
